
import React from 'react'
import ContentLoader from "react-content-loader"
import { memo } from 'react'

const CheckoutHeaderSkeleton = (props) => {
   
        return (

            <div className="checkout-header">
                <ContentLoader className="checkout-header-skeleton"
                    height={25}
                    width={'100%'}
                    speed={2}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="0%" y="0%" rx="0" ry="0" width="35%" height="30" /> {/*logo */}
                    <rect x="60%" y="0%" rx="0" ry="0" width="35%" height="30" /> {/*number */}

                </ContentLoader>
            </div>
        )
    
}

export default memo(CheckoutHeaderSkeleton)